const MuiFormHelperText = {
  styleOverrides: {
    root: {
      marginLeft: '8px',
    },
  },
};

export default MuiFormHelperText;
